export default{
   Men: [
      {
        objectID: 21,
        image: "/static/images/men/3-item-a.jpg",
        name: "Vintage Jean",
        price: "25.75",
        rating: 4
      },
      {
        objectID: 22,
        image: "/static/images/men/2-item-a.jpg",
        name: "Super Jacket",
        price: "25.75",
        rating: 2
      },
      {
        objectID: 23,
        image: "/static/images/men/4-item-a.jpg",
        name: "Leather Jacket",
        price: "55.75",
        rating: 2
      },
      {
        objectID: 24,
        image: "/static/images/men/16-item-a.jpg",
        name: "Winter Jacket",
        price: "29.75",
        rating: 5
      },
      {
        objectID: 25,
        image: "/static/images/men/4-item-a.jpg",
        name: "Blue Jean",
        price: "22.75",
        rating: 2
      }
    ],
   Woman: [
      {
        objectID: 26,
        image: "/static/images/women/13-item-a.jpg",
        name: "White Top",
        price: "55.75",
        rating: 4
      },
      {
        objectID: 27,
        image: "/static/images/women/9-item-c.jpg",
        name: "Bugs Bunny Top",
        price: "45.75",
        rating: 2
      },
      {
        objectID: 28,
        image: "/static/images/women/6-item-a.jpg",
        name: "Striped Jumpsuit",
        price: "72.75",
        rating: 2
      },
      {
        objectID: 29,
        image: "/static/images/women/8-item-a.jpg",
        name: "Black Dress",
        price: "35.75",
        rating: 5
      },
      {
        objectID: 30,
        image: "/static/images/women/14-item-a.jpg",
        name: "Jacket",
        price: "55.75",
        rating: 5
      }
   ],
   Gadgets: [
      {
        objectID: 31,
        image: "/static/images/gadgets/g-1-a.jpg",
        name: "Wired Headphones",
        price: "65.75",
        rating: 4
      },
      {
        objectID: 32,
        image: "/static/images/gadgets/g-2-a.jpg",
        name: "Black Smartphone",
        price: "15.75",
        rating: 2
      },
      {
        objectID: 33,
        image: "/static/images/gadgets/g-3-a.jpg",
        name: "Watch",
        price: "75.75",
        rating: 2
      },
      {
        objectID: 34,
        image: "/static/images/gadgets/g-4-a.jpg",
        name: "Digital Watch",
        price: "25.75",
        rating: 5
      },
      {
        objectID: 35,
        image: "/static/images/gadgets/g-5-a.jpg",
        name: "Circular Speaker",
        price: "45.75",
        rating: 5
      }
   ],
   Accesory: [
      {
        objectID: 36,
        image: "/static/images/accesories/a-1-a.jpg",
        name: "Laptop Bag",
        price: "25.75",
        rating: 4
      },
      {
        objectID: 37,
        image: "/static/images/accesories/a-2-a.jpg",
        name: "Men Belt",
        price: "55.75",
        rating: 2
      },
      {
        objectID: 38,
        image: "/static/images/accesories/a-3-a.jpg",
        name: "Steeel Chain	",
        price: "65.75",
        rating: 2
      },
      {
        objectID: 39,
        image: "/static/images/accesories/a-4-a.jpg",
        name: "Men Purse",
        price: "25.75",
        rating: 5
      },
      {
        objectID: 40,
        image: "/static/images/accesories/a-5-a.jpg",
        name: "Goggles",
        price: "45.75",
        rating: 5
      }
   ]
}